var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FileUploadDataParser = /** @class */ (function () {
    function FileUploadDataParser() {
        this.signedUrlData = [];
    }
    FileUploadDataParser.prototype.parseSignedUrlData = function (signedUrlDataResponse) {
        var parsedData = Object.keys(signedUrlDataResponse).map(function (resourceId) {
            return __assign(__assign({}, signedUrlDataResponse[resourceId]), { resourceId: resourceId });
        });
        this.signedUrlData = parsedData;
        return this.signedUrlData;
    };
    return FileUploadDataParser;
}());
export default FileUploadDataParser;
